/*
 * Article prev/next navigation.
 *
 * Shopify's built-in blog.previous_article / blog.next_article are unreliable
 * for the Articles blog because every migrated article shares one bulk-publish
 * timestamp — tied dates collapse both directions to the same neighbor. So we
 * derive a coherent walk over the full ACTIVE article set client-side from the
 * same search-index.json the predictive search already loads.
 *
 * ONE walk, TWO render targets (canonical-centralization — no divergent second
 * walk): the neighbors are computed once, then used to fill BOTH
 *   - the bottom titled nav  (.article-nav, beneath the article body), and
 *   - the compact top nav next to the Share button (.article-nav-top).
 *
 * The bottom nav is the single source of config via data-attributes:
 *   data-article-handle  — the current article's handle
 *   data-blog-url        — the blog's base URL (e.g. /blogs/articles)
 *   data-index-url       — asset URL of search-index.json
 * The top nav is a pure render target (no data-attributes of its own). This
 * script resolves the neighbors, fills each nav's slots, and unhides. If JS is
 * off, the index can't load, or the current article isn't in the active set
 * (e.g. a news page), the navs stay hidden and the always-present "Browse all
 * articles" link is the fallback.
 */
(function () {
  'use strict';

  var nav = document.querySelector('.article-nav[data-article-handle]');
  if (!nav) return;

  var topNav = document.querySelector('.article-nav-top');

  var indexUrl = nav.getAttribute('data-index-url');
  var blogUrl = (nav.getAttribute('data-blog-url') || '').replace(/\/+$/, '');
  var handle = currentHandle();
  if (!handle || !indexUrl) return;

  fetch(indexUrl)
    .then(function (res) {
      return res.ok ? res.json() : null;
    })
    .then(function (data) {
      if (!data || !Array.isArray(data.articles)) return;

      var articles = data.articles
        .filter(function (a) {
          return a && a.h && a.t;
        })
        .sort(function (a, b) {
          var c = a.t.toLowerCase().localeCompare(b.t.toLowerCase());
          return c !== 0 ? c : a.h.localeCompare(b.h);
        });

      var idx = -1;
      for (var i = 0; i < articles.length; i++) {
        if (articles[i].h === handle) {
          idx = i;
          break;
        }
      }
      if (idx === -1) return;

      var prev = idx > 0 ? articles[idx - 1] : null;
      var next = idx < articles.length - 1 ? articles[idx + 1] : null;

      // ONE computation, TWO render targets.
      var bottomShown = fillSlot('--prev', prev) + fillSlot('--next', next);
      if (bottomShown > 0) nav.hidden = false;

      if (topNav) {
        var topShown = fillTopSlot('--prev', prev) + fillTopSlot('--next', next);
        if (topShown > 0) topNav.hidden = false;
      }
    })
    .catch(function () {
      /* leave the navs hidden — the "Browse all articles" link is the fallback */
    });

  function currentHandle() {
    // The article handle as used in URLs and in search-index.json is the LAST
    // path segment. Liquid's article.handle can render blog-prefixed (e.g.
    // "articles/<slug>"), so the URL is the reliable source; fall back to the
    // data attribute (prefix-stripped) for any unusual routing.
    var parts = location.pathname.split('/').filter(Boolean);
    if (parts.length) return decodeURIComponent(parts[parts.length - 1]);
    var attr = (nav.getAttribute('data-article-handle') || '').split('/').filter(Boolean);
    return attr.length ? attr[attr.length - 1] : '';
  }

  function fillSlot(modifier, article) {
    var link = nav.querySelector('.article-nav__link' + modifier);
    if (!link || !article) return 0;
    link.setAttribute('href', blogUrl + '/' + article.h);
    var titleEl = link.querySelector('.article-nav__title');
    if (titleEl) titleEl.textContent = article.t;
    link.hidden = false;
    return 1;
  }

  function fillTopSlot(modifier, article) {
    var link = topNav.querySelector('.article-nav-top__link' + modifier);
    if (!link || !article) return 0;
    link.setAttribute('href', blogUrl + '/' + article.h);
    // The compact control shows no title; fold the destination title into the
    // aria-label so assistive tech announces where the link goes. The static
    // base ("Previous article" / "Next article") is read from the markup.
    var base = link.getAttribute('aria-label') || '';
    if (base) link.setAttribute('aria-label', base + ': ' + article.t);
    link.hidden = false;
    return 1;
  }
})();
